<template>
	<section class="DashboardPage AbsentDashboardPage">
		<div class="card">
			<div class="title">AFWEZIG</div>
			<div class="users">
				<div class="headers row">
					<span>Medewerker</span>
					<span>Vestiging</span>
					<span>Afwezig vanaf</span>
					<div></div>
				</div>
				<div class="row" v-for="userAvailability in userAvailabilities">
					<span>{{ userAvailability.user.display_name }}</span>
					<span>{{ userAvailability.user.branch }}</span>
					<span>{{ parseDate(userAvailability.date_from) }}</span>
					<div class="buttons">
						<template v-if="showActionButtons(userAvailability)">
							<a :href="`tel:${userAvailability.user.phone}`" class="phone button"><PhoneIcon></PhoneIcon></a>
							<button class="check button" :disabled="isLoading" @click="endIllness(userAvailability.id)">
								<CheckIcon></CheckIcon>
							</button>
						</template>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import PhoneIcon from "vue-feather-icons/icons/PhoneIcon";
import CheckIcon from "vue-feather-icons/icons/CheckIcon";
import {client} from "../../store";
import {parseDate} from "../../utils";
import {mapActions, mapState} from "vuex";
import moment from "moment";

export default {
	name: "Absent",
	components: {CheckIcon, PhoneIcon},

	data() {
		return {
			userAvailabilities: []
		}
	},

	computed: {
		...mapState({
			isLoading: "loading"
		})
	},

	methods: {
		...mapActions({
			setLoading: "map/setLoading",
			setIdle: "map/setIdle"
		}),
		parseDate,

		showActionButtons(userAvailability) {
			return userAvailability.type === "ziekte" && userAvailability.date_till === "";
		},

		getAbsentUsers() {
			client.query(`
				query($filter: String) {
					getUserAvailabilities(filter: $filter) {
						id
						type
						date_from
						user {
							id
							display_name
							phone
							branch
						}
					}
				}`, {
					filter: "current_absent"
				}
			).then(result => {
				this.userAvailabilities = result.getUserAvailabilities;
			}).catch((error) => {
				console.error(error);
				this.$notify({
					group: "app",
					title: "Afwezige gebruikers ophalen mislukt",
					type: "error",
					text: "Er is een fout opgetreden bij het ophalen van de informatie"
				});
			});
		},

		endIllness(id) {
			client.query(`
				mutation($id: ID!, $dateTill: String) {
					updateUserAvailability(id: $id, date_till: $dateTill)
				}`, {
					id: id,
					dateTill: moment().format("YYYY-MM-DD")
				}
			).then(() => {
				this.$notify({
					group: "app",
					title: "Beschikbaarheid aangepast",
					type: "success",
					text: "Succesvol beter gemeld"
				});

				this.getAbsentUsers();
			}).catch((error) => {
				console.error(error);
				this.$notify({
					group: "app",
					title: "Beschikbaarheid aanpassen mislukt",
					type: "error",
					text: "Er is een fout opgetreden bij het aanpassen van de beschikbaarheid"
				});
			});
		}
	},

	beforeMount() {
		this.getAbsentUsers();
	}
}
</script>

<style lang="scss" scoped>
.AbsentDashboardPage {
	height: calc(100% - 44px);
	padding: 24px;

	.card {
		background-color: #FFF;
		padding: 24px;
		border: 3px solid #e0e0e0;

		.title {
			color: #1aae9f;
			font-weight: 800;
			font-size: 1.5em;
			margin-bottom: 24px;
		}

		.users {
			display: flex;
			flex-direction: column;
			gap: 8px;

			.headers {
				font-weight: 800;
				margin-bottom: 8px;
			}

			.row {
				display: flex;
				flex-direction: row;

				span {
					width: calc((100%  - 88px) / 3);
					display: inline-flex;
					align-items: center;
				}

				div {
					width: 88px;
					display: flex;
					flex-direction: row;
					gap: 8px;

					.button {
						display: block;
						padding: 8px 8px 4px 8px;
						border-radius: 4px;
						border: none;
						color: #FFF;

						&.phone {
							background-color: #2c88d9;
						}
						&.check {
							background-color: #1aae9f;
						}
					}
				}
			}
		}
	}
}
</style>
